export default __webpack_public_path__ + "static/media/printing.86ebee39.webp";